import { Button } from "@/components/ui/button";
import ramadanImage from "@/assets/ramadan-kareem.jpg";
import fasttrackLogo from "@/assets/fasttrack-logo.png";

const RamadanWelcome = ({ onContinue }: { onContinue: () => void }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${ramadanImage})` }}
      >
        <div className="absolute inset-0 bg-black/65" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-xl space-y-6 animate-fade-in">
        {/* Company Logo */}
        <img src={fasttrackLogo} alt="FastTrack Solutions KSA" className="h-28 sm:h-36 w-auto mx-auto" />
        
        <p className="text-5xl">🌙</p>
        <h1 className="text-4xl sm:text-5xl font-bold text-white font-elegant">
          رمضان كريم
        </h1>
        <p className="text-white/90 text-lg sm:text-xl leading-relaxed" dir="rtl">
          كل عام وأنتم بخير بمناسبة حلول شهر رمضان المبارك
        </p>
        <p className="text-white/70 text-sm sm:text-base leading-relaxed" dir="rtl">
          أعاده الله علينا وعليكم باليمن والبركات. نسأل الله أن يتقبل منا ومنكم صالح الأعمال وأن يجعله شهر خير وبركة على الجميع.
        </p>
        <p className="text-white/60 text-sm">
          Wishing all Muslims a blessed and peaceful Ramadan.
        </p>
        <p className="text-white/50 text-xs italic">
          — From the FTS Innovation Hub family
        </p>
        <Button
          onClick={onContinue}
          size="lg"
          className="mt-4 bg-white/20 backdrop-blur-sm border border-white/30 text-white hover:bg-white/30 text-base px-8"
        >
          متابعة إلى الموقع ➜
        </Button>
      </div>
    </div>
  );
};

export default RamadanWelcome;
